import { Component, Input, inject } from '@angular/core';
import { Patient } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';

import { RouterLink } from '@angular/router';
import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { SensitiveStringComponent } from '../../../shared/components/sensitive-string/sensitive-string.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { PatientStatusAndDeactivateButtonComponent } from '../patient-status-and-deactivate-button/patient-status-and-deactivate-button.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-patient-grouped-patients',
    templateUrl: './patient-grouped-patients.component.html',
    styleUrls: ['./patient-grouped-patients.component.scss'],
    imports: [RouterLink,
              BlankValueDashComponent,
              SensitiveStringComponent,
              PhoneNumberComponent,
              PatientStatusAndDeactivateButtonComponent,
              BlankValueDashPipe]
})
export class PatientGroupedPatientsComponent {
  private patientService = inject(PatientService);

  @Input() patient: Patient;

  public onSsnAccessed(id: number): void {
    this.patientService.getSsn(id).subscribe(result => {
      if (this.patient.id === id) {
        this.patient.decryptedSsn = result.decryptedSsn;
      } else {
        const sub = this.patient.subPatients.find(subPatient => subPatient.id === id);
        if (sub) sub.decryptedSsn = result.decryptedSsn;
      }
    });
  }
}
